import script from "./EventsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsView.vue?vue&type=script&lang=ts&setup=true"

import "./EventsView.vue?vue&type=style&index=0&id=2f6371dc&lang=scss"

const __exports__ = script;

export default __exports__